// src/i18n.js
import i18n from 'i18next';
import { useTranslation, initReactI18next } from "react-i18next";

import en from './locales/en/translation.json';
import fr from './locales/fr/translation.json';
import ge from './locales/ge/translation.json';
import nl from './locales/nl/translation.json';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  ge: { translation: ge },
  nl: { translation: nl }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
